import { useMutation, useQueryClient } from 'react-query';

import { postDevicesToWarehouse } from 'api/traps/DevicesWareHouse/postTrapsToWarehouse';

const usePostDevicesToWarehouse = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: addDeviceToWarehouse,
    isLoading,
  } = useMutation(postDevicesToWarehouse, {
    onSuccess: () => {
      queryClient.invalidateQueries('DevicesInWarehouse');
    },
  });

  return {
    isSuccess,
    addDeviceToWarehouse,
    isLoading,
  };
};

export default usePostDevicesToWarehouse;
